<template>
  <section>
    <div class="d-flex justify-content-start align-items=end mb-2">
      <b-form-group label="No." class="mr-2">
        <b-form-input v-model="filterObj.requirementLineId" @input="onFilter"></b-form-input>
      </b-form-group>
      <b-form-group label="Part Number" class="mr-2">
        <b-form-input v-model="filterObj.partNumber" @input="onFilter"></b-form-input>
      </b-form-group>
      <b-form-group label="Customer Part Number" class="mr-2">
        <b-form-input v-model="filterObj.customerPartNumber" @input="onFilter"></b-form-input>
      </b-form-group>
      <div class="clear-filter-button-container mt-3">
        <b-button size="sm" @click="onClearFilter">Clear filters</b-button>
      </div>
    </div>
    <grid-component
      isResizable
      isReorderable
      isSortable
      :canEdit="checkClaim(CAN_EDIT_REQUIREMENTS)"
      :canDelete="checkClaim(CAN_DELETE_REQUIREMENTS)"
      :gridId="gridId"
      :pageable="pageable"
      :itemData="itemData"
      :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
      :take="pageInfo.pageSize"
      :pageSizes="pageInfo.pageSize"
      :totalItems="pageInfo.totalItems"
      :sortBy="pageInfo.sortBy"
      :sortOrder="pageInfo.sortOrder"
      :sortMethod="sortGrid"
      :fields="fields"
      :onEdit="pushToDetails"
      :onDelete="onDelete"
      :handleRowClick="onRowClick"
      :navigationField="'partNumber'"
      :isTblLoader="tblLoader"
      :styleCustom="'height: 210px'"
      @getData="onGetData"
    />
  </section>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import { SORT_ORDER, GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from '@/pages/Requirements/fields';

export default {
  components: {
    GridSettings,
    GridComponent
  },
  props: {
    companyId: {
      type: [Number, String],
      default: null,
    },
    partId: {
      type: [String, Number],
      default: null,
    }
  },
  data() {
    return {
      filtersVisible: false,
      fields: gridFields,
      gridId: GRID_ID.REQUIREMENT_LINES_TAB_GRID,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      filterObj: {}
    };
  },
  computed: {
    ...mapGetters('requirementLinesComponent', ['requirementLines','pageInfo', 'filters', 'tblLoader']),
    ...mapGetters('account', ['gridSettingsById']),
    itemData() {
      return this.requirementLines;
    },
  },
  methods: {
    ...mapMutations('requirementLinesComponent', ['setItem']),
    ...mapActions('requirementLinesComponent', ['getAll', 'sortGrid']),
    ...mapActions('requirements', ['deleteRequirementLine']),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
    },
    onFilter: debounce(function() {
      this.setItem({ resource: 'filters', payload: {...this.filters, ...this.filterObj} });
    }, SEARCH_DEBOUNCE_TIME),
    onClearFilter() {
      this.clearObject(this.filterObj);
      this.onFilter();
    },
    pushToDetails(row) {
      this.$router.push({
        name: 'requirements.crfq',
        query: { crfqId: row.requirementId, crfqLineId: row.id, partId: row.partId },
      });
    },
    async onDelete({id, requirementId}) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete requirement line?`});
      if (deleteConfirmed) {
        const result = await this.deleteRequirementLine({id, requirementId}).then(() => this.getAll());
        
      }
    },
    async onGetData(params) {
      await this.getAll(params);
    },
  },
  watch: {
    companyId() {
      this.setItem({ resource: 'filters', payload: {...this.filters, companyId: this.companyId} });
    },
    partId() {
      this.setItem({ resource: 'filters', payload: {...this.filters, partId: this.partId} });
    },
    filters() {
      this.getAll({});
    }
  },
  mounted() {
    this.setItem({resource: 'filters', payload: { companyId: this.companyId, partId: this.partId }});
    // this.getAll({});  
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
  min-width: 800px;
}
</style>
